var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFiltericon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 23.5,
    height: 23.5,
    rx: 3.75,
    stroke: "#E6E6E6",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2691 18.0087C11.0565 18.0087 10.8784 17.9367 10.7348 17.7926C10.5912 17.6485 10.5191 17.4703 10.5186 17.2582V12.7549L6.16543 7.20087C5.9778 6.95069 5.94978 6.688 6.08137 6.4128C6.21297 6.1376 6.44113 6 6.76587 6H17.2735C17.5987 6 17.8272 6.1376 17.9588 6.4128C18.0904 6.688 18.0621 6.95069 17.8739 7.20087L13.5208 12.7549V17.2582C13.5208 17.4708 13.4487 17.6492 13.3046 17.7933C13.1605 17.9374 12.9824 18.0092 12.7702 18.0087H11.2691Z",
    fill: "#8F9094"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiltericon);
export default __webpack_public_path__ + "static/media/filter icon.e3ddac29c4614278b31c404026c6c2ff.svg";
export { ForwardRef as ReactComponent };